import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../components/Layout";
import PopularPosts from "../components/PopularPosts";
import PostList from "../components/PostList";
import { tagTitle, tagLink } from "./tags.module.css";

const Tags = ({ pageContext, data }) => {
  const { tag } = pageContext;
  const { tagged, about, tags, popular } = data;
  const { edges, totalCount } = tagged || {};
  const tagHeader = `${totalCount} post${
    totalCount === 1 ? "" : "s"
  } tagged with "${tag}"`;
  return (
    <Layout>
      <div className={tagTitle}>
        <Link to="/" className={tagLink}>
          Home &gt;
        </Link>
        <h1>{tag}</h1>
      </div>
      <PostList posts={edges} about={about.edges} tags={tags} />
    </Layout>
  );
};

export default Tags;

export const pageQuery = graphql`
  query ($tag: String) {
    tagged: allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date
            featured_image
          }
          excerpt
        }
      }
    }
    popular: allMarkdownRemark(
      filter: { frontmatter: { featured_post: { eq: true } } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          frontmatter {
            date
            title
            featured_image
          }
          fields {
            slug
          }
        }
      }
    }
    about: allMarkdownRemark(
      filter: { frontmatter: { title: { eq: "About" } } }
    ) {
      edges {
        node {
          rawMarkdownBody
        }
      }
    }
    tags: allMarkdownRemark {
      group(field: frontmatter___tags) {
        tag: fieldValue
        totalCount
      }
    }
  }
`;
